import React from "react";
//#region types
import { TodoCardProps } from "models/propTypes/todoPropTypes";
//#endregion
//#region components
import { SupportIssue } from "components/support";
import { useTodoService } from "serviceHooks";
//#endregion

const SupportIssueTodo: React.FC<TodoCardProps> = (props) => {
  const todoService = useTodoService();
  const supportIssue = props.item.supportIssue;

  return (
    <SupportIssue
      supportIssue={supportIssue!}
      reloadHandler={props.onActionSuccess}
      statusIndicatorDisplayType={todoService.getUIDisplayTypeByUrgency(props.item.urgency)}
      enableResolvedCaseConfirmation
    />
  );
};

export default SupportIssueTodo;
